export enum ImportTypesEnum {
    USERS = 'users',
    WALLETS = 'wallets',
}
